(function ($) {
	var w4d = w4d || {};

	w4d.product_gallery = {
		init: function (container) {
			container = container || document;
			var galleries = container.querySelectorAll('.js-product-gallery');
			for (var i = 0; i < galleries.length; i++) {
				var gallery = galleries[i];
				if (gallery.dataset.galleryInitialized) continue;

				this.build_thumbnails(gallery);
				this.init_gallery(gallery);
				this.init_video_play_icons(gallery.closest('.product-gallery'));
				gallery.dataset.galleryInitialized = 'true';
			}
			this.register_events();
			this.init_sidebar_overflow(container);
			this.init_thumbnails_scroll(container);
		},

		init_thumbnails_scroll: function (container) {
			container = container || document;
			const wrappers = container.querySelectorAll('.product-gallery .product-gallery__thumbnails-wrapper');
			if (!wrappers.length) return;

			wrappers.forEach((wrapper) => {
				if (wrapper.dataset.scrollInitialized) return;
				const thumbnails = wrapper.querySelector('.js-thumbnails');
				const productGallery = wrapper.closest('.product-gallery');
				const isVertical = productGallery && productGallery.classList.contains('product-gallery--vertical');

				const btnBegin = wrapper.querySelector(isVertical ? '[data-js-gallery-scroll-up]' : '[data-js-gallery-scroll-left]');
				const btnEnd = wrapper.querySelector(isVertical ? '[data-js-gallery-scroll-down]' : '[data-js-gallery-scroll-right]');

				if (!thumbnails || !btnBegin || !btnEnd) return;

				const updateArrows = () => {
					const hasOverflow = isVertical
						? thumbnails.scrollHeight > thumbnails.clientHeight
						: thumbnails.scrollWidth > thumbnails.clientWidth;

					const scrollPos = isVertical ? thumbnails.scrollTop : thumbnails.scrollLeft;
					const scrollMax = isVertical
						? thumbnails.scrollHeight - thumbnails.clientHeight
						: thumbnails.scrollWidth - thumbnails.clientWidth;

					const isAtStart = scrollPos <= 5;
					const isAtEnd = scrollMax - scrollPos <= 5;

					btnBegin.setAttribute('aria-hidden', hasOverflow && !isAtStart ? 'false' : 'true');
					btnEnd.setAttribute('aria-hidden', hasOverflow && !isAtEnd ? 'false' : 'true');
				};

				// Initial check after a short delay to ensure layout is ready
				setTimeout(updateArrows, 200);

				thumbnails.addEventListener('scroll', updateArrows);

				const resizeObserver = new ResizeObserver(updateArrows);
				resizeObserver.observe(thumbnails);

				const scrollByAmount = (direction) => {
					const firstThumbnail = thumbnails.querySelector('.product-gallery__thumbnail');
					if (!firstThumbnail) return;

					const rect = firstThumbnail.getBoundingClientRect();
					const thumbSize = isVertical ? rect.height : rect.width;
					const gap = parseFloat(getComputedStyle(thumbnails).gap) || 0;

					// Scroll by 4 thumbnails and 3 gaps
					const amount = thumbSize * 4 + gap * 3;

					thumbnails.scrollBy({
						[isVertical ? 'top' : 'left']: direction * amount,
						behavior: 'smooth',
					});
				};

				btnBegin.addEventListener('click', () => scrollByAmount(-1));
				btnEnd.addEventListener('click', () => scrollByAmount(1));

				wrapper.dataset.scrollInitialized = 'true';
			});
		},

		init_sidebar_overflow: function (container) {
			container = container || document;
			const sidebar = container.querySelector('.product-sidebar');
			const chevron = container.querySelector('[data-js-sidebar-show-more]');

			if (!sidebar || !chevron || sidebar.dataset.overflowInitialized) return;

			const checkOverflow = () => {
				const hasOverflow = sidebar.scrollHeight > sidebar.clientHeight + 40;
				const isAtBottom = sidebar.scrollHeight - sidebar.scrollTop <= sidebar.clientHeight + 45;
				const isAtTop = sidebar.scrollTop === 0;

				if (hasOverflow && !isAtBottom) {
					chevron.setAttribute('aria-hidden', 'false');
					chevron.setAttribute('tabindex', '0');
					chevron.setAttribute('aria-expanded', 'false');
				} else {
					chevron.setAttribute('aria-hidden', 'true');
					chevron.setAttribute('tabindex', '-1');
					chevron.setAttribute('aria-expanded', 'true');
				}

				if (isAtTop) {
					// sidebar.style.overscrollBehaviorY = 'auto';
				} else {
					// sidebar.style.overscrollBehaviorY = 'contain';
				}
			};

			// Initial check
			setTimeout(checkOverflow, 100);

			sidebar.addEventListener('scroll', checkOverflow);

			// Check on resize (of the sidebar itself or window)
			const resizeObserver = new ResizeObserver(checkOverflow);
			resizeObserver.observe(sidebar);

			chevron.addEventListener('click', () => {
				const scrollAmount = Math.min(360, sidebar.scrollHeight - sidebar.scrollTop - sidebar.clientHeight);
				sidebar.scrollBy({
					top: scrollAmount,
					behavior: 'smooth',
				});
			});

			sidebar.dataset.overflowInitialized = 'true';
		},

		register_events: function () {
			if (this.events_registered) return;

			$(document).on('click', '.js-thumbnail', (e) => {
				this.handle_thumbnail_click(e);
			});

			$(document).on('keydown', '.js-thumbnail', (e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					this.handle_thumbnail_click(e);
				}
			});

			$(document).on('click', '[data-js="gallery-load-more"]', function () {
				$('.js-product-gallery .product-gallery__item[aria-hidden="true"]').attr('aria-hidden', 'false');
				$(this).remove();
			});

			$(document).on('click', '.variations .variations__remove', (e) => {
				const cart = window.W4D_Cart;
				if (cart != undefined) {
					cart.isClearing = true;
				}

				const $label = $(e.currentTarget).parent();
				const $option = $label.next('.variations__option'); // next element after label

				if ($option.length) {
					// Find any checked radio inside this option and uncheck it
					const $checkedRadio = $option.find('input[type="radio"]:checked');
					if ($checkedRadio.length) {
						$checkedRadio.prop('checked', false).trigger('change');
					}

					// Also reset any select inside this option
					const $select = $option.find('select');
					if ($select.length) {
						$select.val('').trigger('change');
					}
				}

				// Remove last few children (span/i) from the label for UI
				$label.children().slice(-3).remove();

				setTimeout(() => {
					if (cart != undefined) {
						cart.isClearing = false;
					}
				}, 0);
			});

			this.events_registered = true;
		},

		build_thumbnails: function (gallery) {
			var productGallery = gallery.closest('.product-gallery');
			var thumbnailsContainer = productGallery.querySelector('.js-thumbnails');

			if (!thumbnailsContainer) return;

			// Get all the anchor elements (each gallery image)
			var galleryItems = gallery.querySelectorAll('.product-gallery__item');
			for (var i = 0; i < galleryItems.length; i++) {
				var galleryItem = galleryItems[i];
				var img = galleryItem.querySelector('img');

				// Create thumbnail container
				var thumbnail = document.createElement('div');
				thumbnail.classList.add('product-gallery__thumbnail', 'js-thumbnail');
				thumbnail.dataset.id = img.dataset.id ?? 0;
				thumbnail.tabIndex = 0;
				thumbnail.setAttribute('role', 'button');
				thumbnail.setAttribute('aria-label', img.alt || 'Product thumbnail ' + (i + 1));

				// Set the first thumbnail to active
				const params = new URLSearchParams(window.location.search);
				let activeIndex = parseInt(params.get('imgIndex'), 10);
				if (isNaN(activeIndex) || activeIndex < 0) {
					activeIndex = 0;
				}

				if (i === activeIndex) {
					thumbnail.setAttribute('aria-selected', 'true');
				} else {
					thumbnail.setAttribute('aria-selected', 'false');
				}

				// Clone the image from the gallery and append to thumbnail. A processed image's <img> sits in a
				// <picture> (1600/full WebP); the thumbnail uses the small image the item names in data-thumb.
				var thumbnailImage = img.cloneNode(true);
				if (galleryItem.dataset.thumb) {
					thumbnailImage.src = galleryItem.dataset.thumb;
					thumbnailImage.removeAttribute('srcset');
					thumbnailImage.removeAttribute('sizes');
					thumbnailImage.removeAttribute('fetchpriority');
					thumbnailImage.loading = 'lazy';
				}
				thumbnail.appendChild(thumbnailImage);

				// Append the thumbnail to the thumbnails container
				thumbnailsContainer.appendChild(thumbnail);
			}
		},

		init_gallery: function (galleryEl) {
			const el = galleryEl || document.getElementById('lightgallery');
			if (!el || el.dataset.lightgalleryInitialized) return;

			const isLight = el.dataset.lightgalleryLight === '1';

			const instance = lightGallery(el, {
				plugins: [lgZoom, lgThumbnail, lgVideo, lgAutoplay],
				licenseKey: '973A50AB-B5EA-4B1C-9DBC-9E71F46A7925',
				speed: 500,
				selector: '.product-gallery__item',
				// Thumbnail strip from each item's small image, not its full-size <img src>.
				exThumbImage: 'data-thumb',
				zoomFromOrigin: false,
				download: false,
				autoplayFirstVideo: true,
				...(isLight ? { addClass: 'lg--light' } : {}),
			});

			this.init_gallery_back_button(instance, el);
			el.dataset.lightgalleryInitialized = 'true';
		},

		init_gallery_back_button: function (instance, el) {
			let isOpen = false;

			el.addEventListener('lgAfterOpen', () => {
				isOpen = true;
				history.pushState({ lgOpen: true }, '');
			});

			el.addEventListener('lgAfterClose', () => {
				isOpen = false;
			});

			window.addEventListener('popstate', (e) => {
				if (isOpen) {
					isOpen = false;
					instance.closeGallery();
				}
			});
		},

		handle_thumbnail_click: function (e) {
			const clickedThumbnail = e.currentTarget;
			if (!clickedThumbnail) return;

			const productGallery = clickedThumbnail.closest('.product-gallery');
			if (!productGallery) return;

			// --- Scroll if clicked thumbnail is at the edge ---
			const thumbnailsContainer = clickedThumbnail.closest('.js-thumbnails');
			if (thumbnailsContainer) {
				const isVertical = productGallery.classList.contains('product-gallery--vertical');

				const containerRect = thumbnailsContainer.getBoundingClientRect();
				const thumbRect = clickedThumbnail.getBoundingClientRect();
				const gap = parseFloat(getComputedStyle(thumbnailsContainer).gap) || 0;

				const prevThumb = clickedThumbnail.previousElementSibling;
				const nextThumb = clickedThumbnail.nextElementSibling;
				const nextRect = nextThumb ? nextThumb.getBoundingClientRect() : null;
				const prevRect = prevThumb ? prevThumb.getBoundingClientRect() : null;

				if (isVertical) {
					const thumbSize = thumbRect.height + gap;
					// Partially hidden at the top, OR previous thumb is partially hidden at the top
					if (thumbRect.top < containerRect.top + 5 || (prevRect && prevRect.top < containerRect.top + 5)) {
						thumbnailsContainer.scrollBy({ top: -thumbSize, behavior: 'smooth' });
					}
					// Partially hidden at the bottom, OR next thumb is partially hidden at the bottom
					else if (thumbRect.bottom > containerRect.bottom - 5 || (nextRect && nextRect.bottom > containerRect.bottom - 5)) {
						thumbnailsContainer.scrollBy({ top: thumbSize, behavior: 'smooth' });
					}
				} else {
					const thumbSize = thumbRect.width + gap;
					// Partially hidden on the left, OR previous thumb is partially hidden on the left
					if (thumbRect.left < containerRect.left + 5 || (prevRect && prevRect.left < containerRect.left + 5)) {
						thumbnailsContainer.scrollBy({ left: -thumbSize, behavior: 'smooth' });
					}
					// Partially hidden on the right, OR next thumb is partially hidden on the right
					else if (thumbRect.right > containerRect.right - 5 || (nextRect && nextRect.right > containerRect.right - 5)) {
						thumbnailsContainer.scrollBy({ left: thumbSize, behavior: 'smooth' });
					}
				}
			}
			// --------------------------------------------------

			// Aktiviraj kliknuti thumbnail
			productGallery.querySelectorAll('.js-thumbnail').forEach((el) => el.setAttribute('aria-selected', 'false'));
			clickedThumbnail.setAttribute('aria-selected', 'true');

			// Aktiviraj sliku u galeriji (ako postoji)
			const thumbnails = Array.from(productGallery.querySelectorAll('.js-thumbnail'));
			const galleryLinks = productGallery.querySelectorAll('.js-product-gallery .product-gallery__item');
			const index = thumbnails.indexOf(clickedThumbnail);

			if (index !== -1 && galleryLinks[index]) {
				galleryLinks.forEach((el) => el.removeAttribute('aria-current'));
				galleryLinks[index].setAttribute('aria-current', 'true');
			}

			// Uzmi image_id iz thumbnaila
			const imageId = parseInt(clickedThumbnail.dataset.id);
			if (!imageId || isNaN(imageId)) return;

			// Nadji varijaciju prema image_id
			const $mainContainer = $(
				clickedThumbnail.closest('.product-flyout__content') || clickedThumbnail.closest('.product') || document
			);
			const productVariations = $mainContainer.find('.variations_container').data('product_variations');
			if (!Array.isArray(productVariations)) return;

			const matchedVariation = productVariations.find((v) => parseInt(v.image_id) === imageId);
			if (!matchedVariation) return;

			// Postavi selektovane atribute
			const $variationSelects = $mainContainer.find('.variations select');
			const $variationRadios = $mainContainer.find('.variations input[type="radio"]');

			if ($variationSelects.length !== 0 || $variationRadios.length !== 0) {
				Object.entries(matchedVariation.attributes).forEach(([attrName, attrValue]) => {
					// Update select elements
					$variationSelects.filter(`[name="${attrName}"]`).val(attrValue).trigger('change');

					// Update radio buttons
					const $targetRadioGroup = $variationRadios.filter(`[name="${attrName}"]`);
					$targetRadioGroup.prop('disabled', false);
					$targetRadioGroup.prop('checked', false);

					if ($targetRadioGroup.length > 0) {
						const $matchedRadio = $targetRadioGroup.filter(`[value="${attrValue}"]`);

						if ($matchedRadio.length > 0) {
							$matchedRadio.prop('checked', true).trigger('change');
						}
					}
				});
			}

			// Pokreni a~uriranje varijacije
			if (typeof window.W4D_Cart?.updateVariationData === 'function') {
				window.W4D_Cart.updateVariationData(matchedVariation);
			}
		},

		init_video_play_icons: function (container) {
			container = container || document;
			const $template = $('#icon-play');

			$(container)
				.find('.product-gallery__thumbnails-wrapper .product-gallery__thumbnail .video-thumbnail')
				.each(function () {
					const $videoThumb = $(this);
					if ($videoThumb.next().length) return;
					const $icon = $($template.prop('content')).clone();

					$videoThumb.after($icon);
				});
		},
	};

	$(document).ready(function () {
		w4d.product_gallery.init();
	});

	window.w4d = w4d;
})(jQuery);
